<form [formGroup]="selectForm" ui-form>
  <ui-form-item class="form-item">
    <ui-select
      class="deadline-selector"
      [a11yDescription]="a11yDescription"
      [uiOptionHeightPx]="71"
      [reserveScrollbarSpace]="false"
      [uiId]="uiId"
      [uiOptionOverflowSize]="3"
      [uiBorderless]="borderless"
      formControlName="deadline"
      uiDropdownClassName="metric-deadline-select-dropdown-container">
      <ui-option [uiLabel]="'no_custom_deadline' | localize" [uiValue]="'none'" uiCustomContent>
        <div>{{ "no_custom_deadline" | localize }}</div>
        <div class="additional-label">{{ "end_of_session" | localize }}</div>
      </ui-option>

      <ui-option [uiLabel]="'hard_deadline' | localize" [uiValue]="'hardDeadline'" uiCustomContent>
        <div>{{ "hard_deadline" | localize }}</div>
        <div class="additional-label">{{ "date_after_which_kr_cannot_be_updated" | localize }}</div>
      </ui-option>

      <ui-option [uiLabel]="'soft_hard_deadline' | localize" [uiValue]="'hardAndSoftDeadline'" uiCustomContent>
        <div>{{ "soft_hard_deadline" | localize }}</div>
        <div class="additional-label white-space-normal">{{ "after_soft_deadline_progress_discounted_proportionally" | localize }}</div>
      </ui-option>
    </ui-select>
  </ui-form-item>
</form>
<ng-container *featureToggleEnabled="'metric-milestone'">
  <ui-validation-hint *ngIf="showValidationHint" [hintContent]="'chg_hard_deadline_affect_progress_calc' | localize" [isAccented]="true" hintType="info"></ui-validation-hint>
</ng-container>

<div class="soft-deadline sp-mt-8" *ngIf="selectedOption === 'hardAndSoftDeadline'">
  <div class="datepicker-title" *ngIf="showLabels">{{ "soft_deadline" | localize }}</div>
  <ui-date-picker [(ngModel)]="softDeadline" [uiDisabledDate]="checkIfSoftDateIsDisabled" [uiBorderless]="borderless" (ngModelChange)="emitSoftDeadlineChange($event)"></ui-date-picker>
</div>

<div class="hard-deadline sp-mt-8" *ngIf="selectedOption === 'hardAndSoftDeadline' || selectedOption === 'hardDeadline'">
  <div class="datepicker-title" *ngIf="showLabels">{{ "hard_deadline" | localize }}</div>
  <ui-date-picker [(ngModel)]="hardDeadline" [uiDisabledDate]="checkIfHardDateIsDisabled" [uiBorderless]="borderless" (ngModelChange)="emitHardDeadlineChange($event)"></ui-date-picker>
</div>
